{
  "Repo": "https://lba-consulting@dev.azure.com/lba-consulting/Abercrombie%20and%20Kent/_git/AK%20Frontend%20Reservation",
  "LastCommitHash": "da8c3fad633684eeb2cab24e90c5d6c155b514ed",
  "LastCommitMessage": "Merge branch uat_price-setup-changes into dev-update-version19",
  "LastCommitAuthor": "roberto.dipiano",
  "LastCommitTime": "Wed Nov 4 17:03:13 2026 +0100",
  "VersionNumber": "22023"
}